import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer, Loader2 } from "lucide-react";
import SEO from "@/components/SEO";
import InvoiceDocument from "@/components/InvoiceDocument";
import { api } from "@/lib/api";

export default function InvoicePublic() {
  const { token } = useParams();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/invoices/public/${token}`).then(({ data }) => setInv(data)).catch(() => setErr(true)); }, [token]);

  return (
    <>
      <SEO title="Invoice" noindex />
      <div className="min-h-screen bg-[#0B0B0C] py-10 px-4">
        {err ? (
          <div className="max-w-md mx-auto text-center text-muted-c mt-20">This invoice link is invalid or no longer available.</div>
        ) : !inv ? (
          <div className="flex items-center justify-center mt-20 text-muted-c"><Loader2 className="h-5 w-5 animate-spin" /></div>
        ) : (
          <>
            <div className="max-w-[800px] mx-auto mb-4 flex justify-end no-print">
              <button onClick={() => window.print()} data-testid="invoice-print" className="inline-flex items-center gap-2 rounded-xl bg-gold px-5 py-2.5 text-sm font-semibold text-black hover:bg-gold-soft"><Printer className="h-4 w-4" /> Print / Download PDF</button>
            </div>
            <InvoiceDocument inv={inv} />
          </>
        )}
      </div>
    </>
  );
}
